export const ERROR_CODES: { [key: string]: string } = {
  reference_not_found:
    'This reference ID is not found. Please enter a valid Shipment ID otherwise please <a>Create an exception</a>',

  network_error: 'Error processing the request',
  OperationNotPermitted:
    "User doesn't have permissions",
  AccessDeniedException:
    "User doesn't have permissions",
};

export const RECEIVE_TYPES_UI: { [key: string]: string } = {
  SHIPMENT_ID: 'shipment',
  ORDER_NUMBER: 'po',
  INVENTORY_ADJUSTMENT: 'inventory_adjustment',
  RMA_ID: 'no_reference'
};

export const MAX_RESPONSE_TIME = 5000;

export const LAST_TRANSACTIONS_STORED = 20;

export const METRIC_PUBLISHER_NAMES = {
  SCAN_SHIPMENT: 'ScanShipment',
  SCAN_MPN: 'ScanMpn',
  SCAN_CONTAINER: 'ScanContainer',
  SCAN_SERIAL: 'ScanSerial',
  REFERENCE_COPIED: 'ReferenceCopied',
  SCANNER_INPUT_TYPE: 'ScannerInputType',
  SERIALS_RECEIVED: 'SerialsReceived',
};

export const UNKNOWN_MANUFACTURER_PLACEHOLDER = 'UNKNOWN_MANUFACTURER_PLACEHOLDER';

export const UNKNOWN_REFERENCE_LINE_ITEM_PLACEHOLDER = 'UNKNOWN_REFERENCE_LINE_ITEM_PLACEHOLDER';

// total no if serials allowed in a single transaction
export const MAX_SERIALS_IN_TRANSACTION = 1000;

export const MAX_SERIALS_IN_TRANSACTION_ERROR = 'Max limit of 1000 serials per transaction is reached.';
export const SCAN_SERIALS_SPECIAL_CHARACTERS_ERROR = 'Scan serial should not contain special characters';

export const RECEIVE_ERROR_MESSAGES_MAP: { [key: string]: string } = {
  RECEIVE_REFERENCE_NOT_FOUND_VALIDATION: 'Invalid Shipment or PO . Try receiving again with valid shipment or PO.',
  RECEIVE_REFERENCE_INACTIVE_VALIDATION: 'Shipment or PO is closed or Inactive. Try receiving again the valid part.',
  RECEIVED_AT_SITE_NAME_MISSING_VALIDATION: 'Site Name is missing. Try receiving again.',
  RECEIVED_AT_CLUSTER_NAME_MISSING_VALIDATION: 'Cluster Name is missing. Try receiving again.',
  RECEIVE_REFERENCE_CLUSTER_NAME_NOT_FOUND_VALIDATION: 'Something went wrong, try receiving again the valid item.',
  RECEIVE_REFENCE_UNEXPECTED_ERROR: 'Something went wrong, try receiving again the valid model.',
  LINE_ITEM_NOT_EXISTS_VALIDATION: 'Something went wrong, try receiving again the valid model.',
  LINE_ITEM_MAPPING_INCORRECT_VALIDATION: 'Something went wrong, try receiving again the valid model.',
  LINE_ITEM_ERROR_STATUS_VALIDATION: 'Shipment or PO is closed or Inactive. Try receiving again the valid item.',
  LINE_ITEM_NOT_EXISTS_COUNT_RECONCILIATION: 'Something went wrong, try receiving again the valid item.',
  LINE_ITEM_ERROR_STATUS_COUNT_RECONCILIATION: 'Something went wrong, try receiving again the valid item.',
  UPDATE_COUNT_ASN_FAILURE_COUNT_RECONCILIATION: 'Something went wrong, try receiving again the valid item.',
  UPDATE_COUNT_PO_FAILURE_COUNT_RECONCILIATION: 'Something went wrong, try receiving again the valid item.',
  LINE_ITEM_UNEXPECTED_ERROR: 'Something went wrong, try receiving again the valid item.',
  COUNTS_RECONCILIATION_FAILED_UNDERLYING_LINE_ITEM_UPDATE: "Qty reconciliation for associated PO is failed",
  //common error
  COMMON_ERROR: 'Something went wrong, try receiving again the valid item.',
};

